import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component, Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './agent-booking-social-network-qualification.component.ajs';

@Directive({
  selector: 'cng-agent-booking-social-network-qualification-upgrade',
})
export class AgentBookingSocialNetworkQualificationUpgradeComponent extends UpgradeComponent {
  @Input() responseId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-agent-booking-social-network-qualification',
  template:
    '<cng-agent-booking-social-network-qualification-upgrade [responseId]="responseId$ | async"></cng-agent-booking-social-network-qualification-upgrade>',
})
export class AgentBookingSocialNetworkQualificationComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select);

  constructor(private readonly router: AgentDesktopRouter) {}
}
